import { render } from "./PostContainer.vue?vue&type=template&id=3e0b9c58&scoped=true"
import script from "./PostContainer.vue?vue&type=script&lang=js"
export * from "./PostContainer.vue?vue&type=script&lang=js"

import "./post-container.scss?vue&type=style&index=0&id=3e0b9c58&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/gmX3YL_q/0/internal/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e0b9c58"]])

export default __exports__